import store from "../../store";
export default {
  computed: {
    colorClass(){
      let theme = store.getters.defaultColorTheme;
      switch (theme) {
        case "green":
        case "white":
          return "greenTheme";
        case "gray":
          return "grayTheme";
        default:  
          return "blueTheme";
      }
    },
    colorHex() {
      let theme = store.getters.defaultColorTheme;
      switch (theme) {
        case "green":
        case "white":
          return "#94C83B";
        case "gray":
          return "#7f7f7f";
        default:  
          return "#00AEEF";
      }
    },
    borderStyle() {
      return "border-color: " + this.colorHex + " !important;";
    },
    isLightTheme() {
      return store.getters.defaultColorTheme == "white";
    }, 
    coloredLogo() {
      return (this.isLightTheme ? "AXIS Logo for Light Backgrounds - Cropped.png" : "AXIS Logo for Dark Backgrounds - Cropped - Grayscale.png");
    },
    tabClass() {
      return (this.isLightTheme ? "lightTab" : "darkTab");
    },
    coloredAssetUrls() {
      switch (store.getters.defaultColorTheme) {
        case "gray":
          return {
            close: "Gray/Close - Gray.png",
            dropdown: "Gray/Drop Down Menu - Gray.png",
            advancedSearch: "Gray/Advanced Search - Gray.png",
            addPatient: "Gray/Add Patient - Gray.png",
            editPatient: "Gray/Edit Patient - Gray.png",
            manualUpload: "Gray/Manual Exam Upload - Gray.png",
            multiview: "Gray/Multiview - Gray.png",
            proofsheet: "Gray/Proofsheet - Gray.png",
            refresh: "Gray/Refresh - Gray.png",
            stereo:"Gray/gray-stereo-icon.png",
            sideBySide: "Gray/gray-sideBySide-icon.png",
            montage: "Gray/montage-icon-gray.svg",
            overlay: "Gray/gray-overlay-icon.png",
            print: "Gray/gray-print-icon.png",
            annotate: "Gray/gray-pencil-ruler-icon.png",
            download: "Gray/Download - Gray.png",
            save: "Gray/gray-save-icon.png",
            clear: "Gray/gray-trash-icon.png",
            reset: "Gray/gray-reset-icon.png",
            erase: "Gray/gray-erase-annotations-icon.png",
            magnify: "Gray/gray-zoom-icon.png",
            nintyDegree: "Gray/gray-90rotate-icon-clockwise.png",
            oneEightyDegree: "Gray/gray-180-rotate-icon-clockwise.png",
            fitToWindow: "Gray/gray-crop-icon.png",
            drag: "Gray/gray-hand-icon.png",
            arrow: "Gray/gray-arrow-line-icon.png",
            text: "Gray/gray-type-icon.png",
            redacted: "Gray/gray-redacted-icon.png",
            outlined: "Gray/gray-outlinebox-icon.png",
            freehand: "Gray/gray-squiggly-icon.png",
            continuous: "Gray/gray-contDrawing-icon.png",
            angle: "Gray/gray-compass-icon.png",
            line: "Gray/gray-measurements-line-icon.png",
            area: "Gray/gray-measurements-area-icon.png",
            cupToDisc: "Gray/gray-measurements-cupdisc-icon.png",
            freehandArea: "Gray/gray-measurements-freehandArea-icon.png",
            pdt: "Gray/gray-measurements-PDT-icon.png",
            etdrs: "Gray/gray-measurements-etdrsGrid-icon.png",
            smallStandardCircles: "Gray/gray-measurements-standardCircles-icon.png",
            standardCircles: "Gray/gray-measurements-standardCircles34-icon.png",
            smallDrusenCircles: "Gray/gray-measurements-drusen3-icon.png",
            drusenCircles: "Gray/gray-measurements-drusen2-icon.png",
            drusenHalf: "Gray/gray-measurements-drusenHalf-icon.png",
            drusenCircle: "Gray/gray-measurements-drusen1-icon.png",
            rectangle: "Gray/gray-squareArea-icon.png",
            cursor: "Gray/gray-cursor-icon.png",
            microphone: "Gray/Microphone - Gray.png",
            teachingResearch: "Gray/Teaching-Research Case - Gray.png",
            physician: "Gray/Physician - Gray.png",
            diagnosis: "Gray/Diagnosis - Gray.png",
            editPathology: "Gray/gray-pencil-icon.png",
            reports: "Gray/reports-icon-gray.svg",
            usersBackground: "Gray/Users-background-gray.svg",
            physicianBackground: "Gray/Physicians-background-gray.svg",
            devicesBackground: "Gray/Devices-background-gray.svg",
            configure: "Gray/Configure-background-gray.svg",
            returnToAdmin: "Gray/returnToAdmin-icon-gray.svg",
            returnToSingleView: "Gray/gray-Return to Single View - Icon.png",
            calendar: "Gray/calendar-gray.svg",
            printButton: "Gray/printbutton-gray.svg",
            singleView: "Gray/gray-Return to Single View - Icon.png",
            markImage: "Gray/markImages-Icon-gray.svg",
            downloadCircle: "Gray/downloadCircle-icon-gray.svg",
            removeImages: "Gray/removeimages-gray.svg",
            submit: "Gray/gray-Submit.png",
            returnToOverlay: "Gray/registerreturn-icon-gray.svg",
            patientDownload: "Download - White.png",
            patientMic: "Microphone - White.png",
            patientPencil: "White Icons/white-pencil-icon.png",
            patientTeaching: "Teaching-Research Case - White.png",
            patientDiagnosis: "Diagnosis - White.png",
            patientTrash: "Delete - White.png",
            patientPhysician: "Physician - White.png",
            highlighter: "Gray/highlighter-icon-gray.png",
            expand: "Gray/Expand_Icon_April_2022_gray.png",
            minimize: "Gray/Minimize_Icon_April_2022_gray.png",
            lightbulb: "White Icons/white-bulb-icon.png",
            advance: "Gray/AdvanceGray&Black.png",
            mousezoom: "Gray/ZoomGray&Black.png",
            shapeOutline: "Gray/shapeOutline_gray.png",
            shapeFill: "Gray/shapeFill_gray.png"
          };
        case "white": 
          return {
            close: "Green/Close - Green.png",
            dropdown: "Green/Drop Down Menu - Green.png",
            advancedSearch: "Green/Advanced Search - Green.png",
            addPatient: "Green/Add Patient - Green.png",
            editPatient: "Green/Edit Patient - Green.png",
            manualUpload: "Green/Manual Exam Upload - Green.png",
            multiview: "Green/Multiview - Green.png",
            proofsheet: "Green/Proofsheet - Green.png",
            refresh: "Green/Refresh - Green.png",
            stereo:"Green/green-stereo-icon.png",
            sideBySide: "Green/green-sideBySide-icon.png",
            montage: "Green/montage-icon-green.svg",
            overlay: "Green/green-overlay-icon.png",
            print: "Green/green-print-icon.png",
            annotate: "Green/green-pencil-ruler-icon.png",
            download: "Green/Download - Green.png",
            save: "Green/green-save-icon.png",
            clear: "Green/green-trash-icon.png",
            reset: "Green/green-reset-icon.png",
            erase: "Green/green-erase-annotations-icon.png",
            magnify: "Green/green-zoom-icon.png",
            nintyDegree: "Green/green-90rotate-icon.png",
            oneEightyDegree: "Green/green-180-rotate-icon.png",
            fitToWindow: "Green/green-crop-icon.png",
            drag: "Green/green-hand-icon.png",
            arrow: "Green/green-arrow-line-icon.png",
            text: "Green/green-type-icon.png",
            redacted: "Green/green-redacted-icon.png",
            outlined: "Green/green-outlinebox-icon.png",
            freehand: "Green/green-squiggly-icon.png",
            continuous: "Green/green-contDrawing-icon.png",
            angle: "Green/green-compass-icon.png",
            line: "Green/green-measurements-line-icon.png",
            area: "Green/green-measurements-area-icon.png",
            cupToDisc: "Green/green-measurements-cupdisc-icon.png",
            freehandArea: "Green/green-measurements-freehandArea-icon.png",
            pdt: "Green/green-measurements-PDT-icon.png",
            etdrs: "Green/green-measurements-etdrsGrid-icon.png",
            smallStandardCircles: "Green/green-measurements-standardCircles-icon.png",
            standardCircles: "Green/green-measurements-standardCircles34-icon.png",
            smallDrusenCircles: "Green/green-measurements-drusen3-icon.png",
            drusenCircles: "Green/green-measurements-drusen2-icon.png",
            drusenHalf: "Green/green-measurements-drusenHalf-icon.png",
            drusenCircle: "Green/green-measurements-drusen1-icon.png",
            rectangle: "Green/green-squareArea-icon.png",
            cursor: "Green/green-cursor-icon.png",
            microphone: "Green/Microphone - Green.png",
            teachingResearch: "Green/Teaching-Research Case - Green.png",
            physician: "Green/Physician - Green.png",
            diagnosis: "Green/Diagnosis - Green.png",
            editPathology: "Green/green-pencil-icon.png",
            reports: "Green/reports-icon-green.svg",
            usersBackground: "Green/Users-background-green.svg",
            physicianBackground: "Green/Physicians-background-green.svg",
            devicesBackground: "Green/Devices-background-green.svg",
            configure: "Green/Configure-background-green.svg",
            returnToAdmin: "Green/returnToAdmin-icon-green.svg",
            returnToSingleView: "Green/green-Return to Single View - Icon.png",
            calendar: "Green/calendar-green.svg",
            printButton: "Green/printbutton-green.svg",
            singleView: "Green/green-Return to Single View - Icon.png",
            markImage: "Green/markImages-Icon-green.svg",
            downloadCircle: "Green/downloadCircle-icon-green.svg",
            submit: "Green/green-Submit.png",
            removeImages: "Green/removeimages-green.svg",
            returnToOverlay: "Green/registerreturn-icon-green.svg",
            patientDownload: "Download - Dark Gray.png",
            patientMic: "Gray/Microphone - Gray.png",
            patientPencil: "Gray/gray-pencil-icon.png",
            patientTeaching: "Teaching-Research Case - Dark Gray.png",
            patientDiagnosis: "Diagnosis - Dark Gray.png",
            patientTrash: "Delete - Dark Gray.png",
            patientPhysician: "Physician - Drak Gray.png",
            highlighter: "Green/highlighter-icon-green.png",
            expand: "Green/Expand_Icon_April_2022_green.png",
            minimize: "Green/Minimize_Icon_April_2022_green.png",
            lightbulb: "Best Practices and Tips Bullet Point.png",
            advance: "Green/AdvanceGreen&White.png",
            mousezoom: "Green/ZoomGreen&White.png",
            shapeOutline: "Green/shapeOutline_green.png",
            shapeFill: "Green/shapeFill_green.png"
          };
        case "green": 
          return {
            close: "Green/Close - Green.png",
            dropdown: "Green/Drop Down Menu - Green.png",
            advancedSearch: "Green/Advanced Search - Green.png",
            addPatient: "Green/Add Patient - Green.png",
            editPatient: "Green/Edit Patient - Green.png",
            manualUpload: "Green/Manual Exam Upload - Green.png",
            multiview: "Green/Multiview - Green.png",
            proofsheet: "Green/Proofsheet - Green.png",
            refresh: "Green/Refresh - Green.png",
            stereo:"Green/green-stereo-icon.png",
            sideBySide: "Green/green-sideBySide-icon.png",
            montage: "Green/montage-icon-green.svg",
            overlay: "Green/green-overlay-icon.png",
            print: "Green/green-print-icon.png",
            annotate: "Green/green-pencil-ruler-icon.png",
            download: "Green/Download - Green.png",
            save: "Green/green-save-icon.png",
            clear: "Green/green-trash-icon.png",
            reset: "Green/green-reset-icon.png",
            erase: "Green/green-erase-annotations-icon.png",
            magnify: "Green/green-zoom-icon.png",
            nintyDegree: "Green/green-90rotate-icon.png",
            oneEightyDegree: "Green/green-180-rotate-icon.png",
            fitToWindow: "Green/green-crop-icon.png",
            drag: "Green/green-hand-icon.png",
            arrow: "Green/green-arrow-line-icon.png",
            text: "Green/green-type-icon.png",
            redacted: "Green/green-redacted-icon.png",
            outlined: "Green/green-outlinebox-icon.png",
            freehand: "Green/green-squiggly-icon.png",
            continuous: "Green/green-contDrawing-icon.png",
            angle: "Green/green-compass-icon.png",
            line: "Green/green-measurements-line-icon.png",
            area: "Green/green-measurements-area-icon.png",
            cupToDisc: "Green/green-measurements-cupdisc-icon.png",
            freehandArea: "Green/green-measurements-freehandArea-icon.png",
            pdt: "Green/green-measurements-PDT-icon.png",
            etdrs: "Green/green-measurements-etdrsGrid-icon.png",
            smallStandardCircles: "Green/green-measurements-standardCircles-icon.png",
            standardCircles: "Green/green-measurements-standardCircles34-icon.png",
            smallDrusenCircles: "Green/green-measurements-drusen3-icon.png",
            drusenCircles: "Green/green-measurements-drusen2-icon.png",
            drusenHalf: "Green/green-measurements-drusenHalf-icon.png",
            drusenCircle: "Green/green-measurements-drusen1-icon.png",
            rectangle: "Green/green-squareArea-icon.png",
            cursor: "Green/green-cursor-icon.png",
            microphone: "Green/Microphone - Green.png",
            teachingResearch: "Green/Teaching-Research Case - Green.png",
            physician: "Green/Physician - Green.png",
            diagnosis: "Green/Diagnosis - Green.png",
            editPathology: "Green/green-pencil-icon.png",
            reports: "Green/reports-icon-green.svg",
            usersBackground: "Green/Users-background-green.svg",
            physicianBackground: "Green/Physicians-background-green.svg",
            devicesBackground: "Green/Devices-background-green.svg",
            configure: "Green/Configure-background-green.svg",
            returnToAdmin: "Green/returnToAdmin-icon-green.svg",
            returnToSingleView: "Green/green-Return to Single View - Icon.png",
            calendar: "Green/calendar-green.svg",
            printButton: "Green/printbutton-green.svg",
            singleView: "Green/green-Return to Single View - Icon.png",
            markImage: "Green/markImages-Icon-green.svg",
            downloadCircle: "Green/downloadCircle-icon-green.svg",
            removeImages: "Green/removeimages-green.svg",
            submit: "Green/green-Submit.png",
            returnToOverlay: "Green/registerreturn-icon-green.svg",
            patientDownload: "Download - White.png",
            patientMic: "Microphone - White.png",
            patientPencil: "White Icons/white-pencil-icon.png",
            patientTeaching: "Teaching-Research Case - White.png",
            patientDiagnosis: "Diagnosis - White.png",
            patientTrash: "Delete - White.png",
            patientPhysician: "Physician - White.png",
            highlighter: "Green/highlighter-icon-green.png",
            expand: "Green/Expand_Icon_April_2022_green.png",
            minimize: "Green/Minimize_Icon_April_2022_green.png",
            lightbulb: "White Icons/white-bulb-icon.png",
            advance: "Green/AdvanceGreen&Black.png",
            mousezoom: "Green/ZoomGreen&Black.png",
            shapeOutline: "Green/shapeOutline_green.png",
            shapeFill: "Green/shapeFill_green.png"
          };
        default:
          return {
            close: "Blue/Close - Blue.png",
            dropdown: "Blue/Drop Down Menu - Blue.png",
            advancedSearch: "Blue/Advanced Search - Blue.png",
            addPatient: "Blue/Add Patient - Blue.png",
            editPatient: "Blue/Edit Patient - Blue.png",
            manualUpload: "Blue/Manual Exam Upload - Blue.png",
            multiview: "Blue/Multiview - Blue.png",
            proofsheet: "Blue/Proofsheet - Blue.png",
            refresh: "Blue/Refresh - Blue.png",
            stereo:"Blue/blue-stereo-icon.png",
            sideBySide: "Blue/blue-sideBySide-icon.png",
            montage: "Blue/montage-icon-blue.svg",
            overlay: "Blue/blue-overlay-icon.png",
            print: "Blue/blue-print-icon.png",
            annotate: "Blue/blue-pencil-ruler-icon.png",
            download: "Blue/Download - Blue.png",
            save: "Blue/blue-save-icon.png",
            clear: "Blue/blue-trash-icon.png",
            reset: "Blue/blue-reset-icon.png",
            erase: "Blue/blue-erase-annotations-icon.png",
            magnify: "Blue/blue-zoom-icon.png",
            nintyDegree: "Blue/blue-90rotate-icon.png",
            oneEightyDegree: "Blue/blue-180-rotate-icon.png",
            fitToWindow: "Blue/blue-crop-icon.png",
            drag: "Blue/blue-hand-icon.png",
            arrow: "Blue/blue-arrow-line-icon.png",
            text: "Blue/blue-type-icon.png",
            redacted: "Blue/blue-redacted-icon.png",
            outlined: "Blue/blue-outlinebox-icon.png",
            freehand: "Blue/blue-squiggly-icon.png",
            continuous: "Blue/blue-contDrawing-icon.png",
            angle: "Blue/blue-compass-icon.png",
            line: "Blue/blue-measurements-line-icon.png",
            area: "Blue/blue-measurements-area-icon.png",
            cupToDisc: "Blue/blue-measurements-cupdisc-icon.png",
            freehandArea: "Blue/blue-measurements-freehandArea-icon.png",
            pdt: "Blue/blue-measurements-PDT-icon.png",
            etdrs: "Blue/blue-measurements-etdrsGrid-icon.png",
            smallStandardCircles: "Blue/blue-measurements-standardCircles-icon.png",
            standardCircles: "Blue/blue-measurements-standardCircles34-icon.png",
            smallDrusenCircles: "Blue/blue-measurements-drusen3-icon.png",
            drusenCircles: "Blue/blue-measurements-drusen2-icon.png",
            drusenHalf: "Blue/blue-measurements-drusenHalf-icon.png",
            drusenCircle: "Blue/blue-measurements-drusen1-icon.png",
            rectangle: "Blue/blue-squareArea-icon.png",
            cursor: "Blue/blue-cursor-icon.png",
            microphone: "Blue/Microphone - Blue.png",
            teachingResearch: "Blue/Teaching-Research Case - Blue.png",
            physician: "Blue/Physician - Blue.png",
            diagnosis: "Blue/Diagnosis - Blue.png",
            editPathology: "Blue/blue-pencil-icon.png",
            reports: "Blue/reports-icon-blue.svg",
            usersBackground: "Blue/Users-background-blue.svg",
            physicianBackground: "Blue/Physicians-background-blue.svg",
            devicesBackground: "Blue/Devices-background-blue.svg",
            configure: "Blue/Configure-background-blue.svg",
            returnToAdmin: "Blue/returnToAdmin-icon-blue.svg",
            returnToSingleView: "Blue/blue-Return to Single View - Icon.jpg",
            calendar: "Blue/calendar-blue.svg",
            printButton: "Blue/printbutton-blue.svg",
            singleView: "Blue/blue-Return to Single View - Icon.jpg",
            markImage: "Blue/markImages-Icon-blue.svg",
            downloadCircle: "Blue/downloadCircle-icon-blue.svg",
            removeImages: "Blue/removeimages-blue.svg",
            submit: "Blue/Submit_-_Blue.png",
            returnToOverlay: "Blue/registerreturn-icon-blue.svg",
            patientDownload: "Download - White.png",
            patientMic: "Microphone - White.png",
            patientPencil: "White Icons/white-pencil-icon.png",
            patientTeaching: "Teaching-Research Case - White.png",
            patientDiagnosis: "Diagnosis - White.png",
            patientTrash: "Delete - White.png",
            patientPhysician: "Physician - White.png",
            highlighter: "Blue/highlighter-icon-blue.png",
            expand: "Blue/Expand_Icon_April_2022_blue.png",
            minimize: "Blue/Minimize_Icon_April_2022_blue.png",
            lightbulb: "White Icons/white-bulb-icon.png",
            advance: "Blue/AdvanceBlue&Black.png",
            mousezoom: "Blue/ZoomBlue&Black.png",
            shapeOutline: "Blue/shapeOutline_blue.png",
            shapeFill: "Blue/shapeFill_blue.png"
          };
      }
    },
    activeAnnotationIcons() {
      switch (store.getters.defaultColorTheme) {
        case "white":
          return {
            erase: "Gray/gray-erase-annotations-icon.png",
            magnify: "Gray/gray-zoom-icon.png",
            nintyDegree: "Gray/gray-90rotate-icon.png",
            oneEightyDegree: "Gray/gray-180-rotate-icon.png",
            drag: "Gray/gray-hand-icon.png",
            arrow: "Gray/gray-arrow-line-icon.png",
            text: "Gray/gray-type-icon.png",
            redacted: "Gray/gray-redacted-icon.png",
            outlined: "Gray/gray-outlinebox-icon.png",
            freehand: "Gray/gray-squiggly-icon.png",
            continuous: "Gray/gray-contDrawing-icon.png",
            angle: "Gray/gray-compass-icon.png",
            line: "Gray/gray-measurements-line-icon.png",
            area: "Gray/gray-measurements-area-icon.png",
            cupToDisc: "Gray/gray-measurements-cupdisc-icon.png",
            freehandArea: "Gray/gray-measurements-freehandArea-icon.png",
            pdt: "Gray/gray-measurements-PDT-icon.png",
            etdrs: "Gray/gray-measurements-etdrsGrid-icon.png",
            smallStandardCircles: "Gray/gray-measurements-standardCircles-icon.png",
            standardCircles: "Gray/gray-measurements-standardCircles34-icon.png",
            smallDrusenCircles: "Gray/gray-measurements-drusen3-icon.png",
            drusenCircles: "Gray/gray-measurements-drusen2-icon.png",
            drusenHalf: "Gray/gray-measurements-drusenHalf-icon.png",
            drusenCircle: "Gray/gray-measurements-drusen1-icon.png",
            rectangle: "Gray/gray-squareArea-icon.png",
            cursor: "Gray/gray-cursor-icon.png",
            annotate: "Gray/gray-pencil-ruler-icon.png",
            highlighter: "Gray/highlighter-icon-gray.png",
            expand: "Gray/Expand_Icon_April_2022_gray.png",
            minimize: "Gray/Minimize_Icon_April_2022_gray.png",
            advance: "Gray/AdvanceGray&White.png",
            mousezoom: "Gray/ZoomGray&White.png",
            shapeOutline: "Gray/shapeOutline_gray.png",
            shapeFill: "White/shapeFill_white.png",
          };
        default: 
          return {
            erase: "White Icons/erase-annotations-icon.png",
            magnify: "White Icons/magnify-white-icon.png",
            nintyDegree: "White Icons/white-90-rotate-clockwise-icon(1).png",
            oneEightyDegree: "White Icons/rotate-white-icon.png",
            drag: "White Icons/hand-white-icon.png",
            arrow: "White Icons/arrow-whiteIcon.png",
            text: "White Icons/test-white-icon.png",
            redacted: "White Icons/redact-white-icon.png",
            outlined: "White Icons/outlinebox-white-icon.png",
            freehand: "White Icons/freedraw-white-icon.png",
            continuous: "White Icons/white-contDrawing-icon.png",
            angle: "White Icons/compass-white-icon.png",
            line: "White Icons/measurements-line-icon.png",
            area: "White Icons/measurements-area-icon.png",
            cupToDisc: "White Icons/measurements-cupdisc-icon.png",
            freehandArea: "White Icons/measurements-freehandArea-icon.png",
            pdt: "White Icons/measurements-PDT-icon.png",
            etdrs: "White Icons/measurements-etdrsGrid-icon.png",
            smallStandardCircles: "White Icons/measurements-standardCircles-icon.png",
            standardCircles: "White Icons/measurements-standardCircles34-icon.png",
            smallDrusenCircles: "White Icons/measurements-drusen3-icon.png",
            drusenCircles: "White Icons/measurements-drusen2-icon.png",
            drusenHalf: "White Icons/measurements-drusenHalf-icon.png",
            drusenCircle: "White Icons/measurements-drusen1-icon.png",
            rectangle: "White Icons/white-squareArea-icon.png",
            cursor: "White Icons/arrow-white-icon.png",
            annotate: "White Icons/annotate-white-icon.png",
            highlighter: "White Icons/highlighter-icon-white.png",
            expand: "White Icons/Expand_Icon_April_2022_white.png",
            minimize: "White Icons/Minimize_Icon_April_2022_white.png",
            advance: "Gray/AdvanceWhite&Black.png",
            mousezoom: "Gray/ZoomWhite&Black.png",
            shapeOutline: "White/shapeOutline_white.png",
            shapeFill: "White/shapeFill_white.png"
          };
      }
    }
  }
}